import React from 'react'
import { sectorService } from '@cabukaka/services';
import { Sector } from '@cabukaka/types';
import useDataById from '../core/useDataById';

export  function useSector({ id }: { id: string }) {
    const {
        data: sector,
        loading,
        error,
        deleteItem,
        updateItem
    } = useDataById<Sector>({ service: {
        ...sectorService,
        ...sectorService.baseService
    }, id });

    return {
     sector,
     error,
     loading,
     deleteSector: deleteItem,
     updateSector: updateItem,
    }

}
